import React, { FC } from 'react'
import styled from 'styled-components'
import { useTimeout } from 'react-nb-hooks'
import { Grid, Message } from 'semantic-ui-react'
import { LKIcon } from 'loankeeper-common/components'
//@ts-ignore
import { GridContainer } from 'shared/StyledComponents'

const MessageWrapper = styled(Message)`
  position: absolute !important;
  bottom: 60px;
  width: 250px;
  padding: 10px 20px 10px 5px !important;
  z-index: 1000;

  .message-container {
    padding: 0;
  }
`

const StatusBarNotification: FC<{
  className: string
  notificationMessage: string
}> = ({ className, notificationMessage }) => {
  const [isHidden, setHidden] = React.useState(false)

  const handleDismiss = React.useCallback(() => setHidden(true), [setHidden])

  useTimeout(handleDismiss, 10000) // 10 sec

  if (isHidden) {
    return null
  }

  return (
    <MessageWrapper className={className} onDismiss={handleDismiss} compact>
      <GridContainer className="message-container">
        <Grid>
          <Grid.Row>
            <Grid.Column width={3}>
              <LKIcon alias="alert" />
            </Grid.Column>
            <Grid.Column width={13}>
              <span>{notificationMessage}</span>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </GridContainer>
    </MessageWrapper>
  )
}

export default StatusBarNotification
